import type { DocumentPath } from './types';

export const PILOT_AUTO_DOCS_PATH: { drivingState: DocumentPath } = {
  drivingState: {
    ja: '/reference-design/common/software-specification#%E7%8A%B6%E6%85%8B%E9%81%B7%E7%A7%BB',
    'en-US':
      '/reference-design/common/software-specification#state-transition-of-pilotauto',
  },
};
